import React from "react";
import styles from "./LoadingIndicator.module.css";

interface LoadingIndicatorProps {
  size?: "small" | "medium" | "large";
  text?: string;
  className?: string; // Allow parent to pass custom classes
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  size = "medium",
  text,
  className = "",
}) => {
  return (
    <div className={`${styles.loadingIndicatorContainer} ${className}`}>
      <div className={`${styles.loadingIndicator} ${styles[size]}`}>
        <div className={`${styles.dot} ${styles.dot1}`}></div>
        <div className={`${styles.dot} ${styles.dot2}`}></div>
        <div className={`${styles.dot} ${styles.dot3}`}></div>
      </div>
      {text && <span className={styles.loadingText}>{text}</span>}
    </div>
  );
};

export default LoadingIndicator;
